export default "assets/images/icons/shop-2ada00e1.svg";